import React, { SVGProps } from 'react';

export const WorkspaceSVG = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_3366_12624)'>
      <path d='M12.51 3.48999V14.15' stroke='#252F3F' strokeWidth='0.88' strokeLinecap='round' strokeLinejoin='round' />
      <path
        d='M3.48999 3.48999H12.51'
        stroke='#252F3F'
        strokeWidth='0.88'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M3.48999 14.15V3.48999'
        stroke='#252F3F'
        strokeWidth='0.88'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.51 14.1499H3.48999'
        stroke='#252F3F'
        strokeWidth='0.88'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.51 3.48998H3.48999L4.30999 1.84998H11.69L12.51 3.48998Z'
        stroke='#252F3F'
        strokeWidth='0.88'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M1.8501 14.1499H14.1501'
        stroke='#252F3F'
        strokeWidth='0.88'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.23002 12.9199C9.23002 12.5937 9.10043 12.2809 8.86976 12.0502C8.63909 11.8195 8.32624 11.6899 8.00002 11.6899C7.6738 11.6899 7.36095 11.8195 7.13028 12.0502C6.89961 12.2809 6.77002 12.5937 6.77002 12.9199V14.1499H9.23002V12.9199Z'
        stroke='#252F3F'
        strokeWidth='0.88'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.53996 5.33505C5.48559 5.33505 5.43345 5.31345 5.395 5.27501C5.35656 5.23656 5.33496 5.18442 5.33496 5.13005C5.33496 5.07568 5.35656 5.02354 5.395 4.98509C5.43345 4.94665 5.48559 4.92505 5.53996 4.92505'
        stroke='#252F3F'
        strokeWidth='0.88'
      />
      <path
        d='M5.54004 5.33505C5.59441 5.33505 5.64655 5.31345 5.685 5.27501C5.72344 5.23656 5.74504 5.18442 5.74504 5.13005C5.74504 5.07568 5.72344 5.02354 5.685 4.98509C5.64655 4.94665 5.59441 4.92505 5.54004 4.92505'
        stroke='#252F3F'
        strokeWidth='0.88'
      />
      <path
        d='M7.99992 5.33505C7.94555 5.33505 7.89341 5.31345 7.85496 5.27501C7.81652 5.23656 7.79492 5.18442 7.79492 5.13005C7.79492 5.07568 7.81652 5.02354 7.85496 4.98509C7.89341 4.94665 7.94555 4.92505 7.99992 4.92505'
        stroke='#252F3F'
        strokeWidth='0.88'
      />
      <path
        d='M8 5.33505C8.05437 5.33505 8.10651 5.31345 8.14496 5.27501C8.1834 5.23656 8.205 5.18442 8.205 5.13005C8.205 5.07568 8.1834 5.02354 8.14496 4.98509C8.10651 4.94665 8.05437 4.92505 8 4.92505'
        stroke='#252F3F'
        strokeWidth='0.88'
      />
      <path
        d='M10.4599 5.33505C10.4055 5.33505 10.3534 5.31345 10.3149 5.27501C10.2765 5.23656 10.2549 5.18442 10.2549 5.13005C10.2549 5.07568 10.2765 5.02354 10.3149 4.98509C10.3534 4.94665 10.4055 4.92505 10.4599 4.92505'
        stroke='#252F3F'
        strokeWidth='0.88'
      />
      <path
        d='M10.46 5.33505C10.5143 5.33505 10.5665 5.31345 10.6049 5.27501C10.6434 5.23656 10.665 5.18442 10.665 5.13005C10.665 5.07568 10.6434 5.02354 10.6049 4.98509C10.5665 4.94665 10.5143 4.92505 10.46 4.92505'
        stroke='#252F3F'
        strokeWidth='0.88'
      />
      <path
        d='M5.53996 7.79501C5.48559 7.79501 5.43345 7.77341 5.395 7.73497C5.35656 7.69652 5.33496 7.64438 5.33496 7.59001C5.33496 7.53564 5.35656 7.4835 5.395 7.44505C5.43345 7.40661 5.48559 7.38501 5.53996 7.38501'
        stroke='#252F3F'
        strokeWidth='0.88'
      />
      <path
        d='M5.54004 7.79501C5.59441 7.79501 5.64655 7.77341 5.685 7.73497C5.72344 7.69652 5.74504 7.64438 5.74504 7.59001C5.74504 7.53564 5.72344 7.4835 5.685 7.44505C5.64655 7.40661 5.59441 7.38501 5.54004 7.38501'
        stroke='#252F3F'
        strokeWidth='0.88'
      />
      <path
        d='M7.99992 7.79501C7.94555 7.79501 7.89341 7.77341 7.85496 7.73497C7.81652 7.69652 7.79492 7.64438 7.79492 7.59001C7.79492 7.53564 7.81652 7.4835 7.85496 7.44505C7.89341 7.40661 7.94555 7.38501 7.99992 7.38501'
        stroke='#252F3F'
        strokeWidth='0.88'
      />
      <path
        d='M8 7.79501C8.05437 7.79501 8.10651 7.77341 8.14496 7.73497C8.1834 7.69652 8.205 7.64438 8.205 7.59001C8.205 7.53564 8.1834 7.4835 8.14496 7.44505C8.10651 7.40661 8.05437 7.38501 8 7.38501'
        stroke='#252F3F'
        strokeWidth='0.88'
      />
      <path
        d='M10.4599 7.79501C10.4055 7.79501 10.3534 7.77341 10.3149 7.73497C10.2765 7.69652 10.2549 7.64438 10.2549 7.59001C10.2549 7.53564 10.2765 7.4835 10.3149 7.44505C10.3534 7.40661 10.4055 7.38501 10.4599 7.38501'
        stroke='#252F3F'
        strokeWidth='0.88'
      />
      <path
        d='M10.46 7.79501C10.5143 7.79501 10.5665 7.77341 10.6049 7.73497C10.6434 7.69652 10.665 7.64438 10.665 7.59001C10.665 7.53564 10.6434 7.4835 10.6049 7.44505C10.5665 7.40661 10.5143 7.38501 10.46 7.38501'
        stroke='#252F3F'
        strokeWidth='0.88'
      />
      <path
        d='M5.53996 10.255C5.48559 10.255 5.43345 10.2334 5.395 10.1949C5.35656 10.1565 5.33496 10.1043 5.33496 10.05C5.33496 9.9956 5.35656 9.94346 5.395 9.90501C5.43345 9.86657 5.48559 9.84497 5.53996 9.84497'
        stroke='#252F3F'
        strokeWidth='0.88'
      />
      <path
        d='M5.54004 10.255C5.59441 10.255 5.64655 10.2334 5.685 10.1949C5.72344 10.1565 5.74504 10.1043 5.74504 10.05C5.74504 9.9956 5.72344 9.94346 5.685 9.90501C5.64655 9.86657 5.59441 9.84497 5.54004 9.84497'
        stroke='#252F3F'
        strokeWidth='0.88'
      />
      <path
        d='M7.99992 10.255C7.94555 10.255 7.89341 10.2334 7.85496 10.1949C7.81652 10.1565 7.79492 10.1043 7.79492 10.05C7.79492 9.9956 7.81652 9.94346 7.85496 9.90501C7.89341 9.86657 7.94555 9.84497 7.99992 9.84497'
        stroke='#252F3F'
        strokeWidth='0.88'
      />
      <path
        d='M8 10.255C8.05437 10.255 8.10651 10.2334 8.14496 10.1949C8.1834 10.1565 8.205 10.1043 8.205 10.05C8.205 9.9956 8.1834 9.94346 8.14496 9.90501C8.10651 9.86657 8.05437 9.84497 8 9.84497'
        stroke='#252F3F'
        strokeWidth='0.88'
      />
      <path
        d='M10.4599 10.255C10.4055 10.255 10.3534 10.2334 10.3149 10.1949C10.2765 10.1565 10.2549 10.1043 10.2549 10.05C10.2549 9.9956 10.2765 9.94346 10.3149 9.90501C10.3534 9.86657 10.4055 9.84497 10.4599 9.84497'
        stroke='#252F3F'
        strokeWidth='0.88'
      />
      <path
        d='M10.46 10.255C10.5143 10.255 10.5665 10.2334 10.6049 10.1949C10.6434 10.1565 10.665 10.1043 10.665 10.05C10.665 9.9956 10.6434 9.94346 10.6049 9.90501C10.5665 9.86657 10.5143 9.84497 10.46 9.84497'
        stroke='#252F3F'
        strokeWidth='0.88'
      />
    </g>
    <defs>
      <clipPath id='clip0_3366_12624'>
        <rect width='14' height='14' fill='white' transform='translate(1 1)' />
      </clipPath>
    </defs>
  </svg>
);
